/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_HeadingInputs */

const en_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Mark Egly`)
};

const es_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre Mark Egly`)
};

const de_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Mark Egly`)
};

const zh_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 Mark Egly`)
};

const ar_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عن Mark Egly`)
};

const fr_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos de Mark Egly`)
};

const vi_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về Mark Egly`)
};

const sw_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuhusu Mark Egly`)
};

const th_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับ Mark Egly`)
};

const bs_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Marku Eglyju`)
};

const ja_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Eglyについて`)
};

const ko_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly 소개`)
};

const pt_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o Mark Egly`)
};

const it_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni su Mark Egly`)
};

const sv_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Mark Egly`)
};

const nl_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over Mark Egly`)
};

const da_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Mark Egly`)
};

const nb_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Mark Egly`)
};

const fi_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa Mark Eglystä`)
};

const pl_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Marku Eglym`)
};

const ru_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О тренере Mark Egly`)
};

const tr_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Hakkında`)
};

const hi_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly के बारे में`)
};

const id_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang Mark Egly`)
};

const ms_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang Mark Egly`)
};

const cs_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Marku Eglym`)
};

const el_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σχετικά με το Mark Egly`)
};

const he_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const af_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oor Mark Egly`)
};

const hu_about_heading = /** @type {(inputs: About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

/**
* | output |
* | --- |
* | "About Mark Egly" |
*
* @param {About_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_heading = /** @type {((inputs?: About_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_heading(inputs)
	if (locale === "de") return de_about_heading(inputs)
	if (locale === "zh") return zh_about_heading(inputs)
	if (locale === "ar") return ar_about_heading(inputs)
	if (locale === "fr") return fr_about_heading(inputs)
	if (locale === "vi") return vi_about_heading(inputs)
	if (locale === "sw") return sw_about_heading(inputs)
	if (locale === "th") return th_about_heading(inputs)
	if (locale === "bs") return bs_about_heading(inputs)
	if (locale === "ja") return ja_about_heading(inputs)
	if (locale === "ko") return ko_about_heading(inputs)
	if (locale === "pt") return pt_about_heading(inputs)
	if (locale === "it") return it_about_heading(inputs)
	if (locale === "sv") return sv_about_heading(inputs)
	if (locale === "nl") return nl_about_heading(inputs)
	if (locale === "da") return da_about_heading(inputs)
	if (locale === "nb") return nb_about_heading(inputs)
	if (locale === "fi") return fi_about_heading(inputs)
	if (locale === "pl") return pl_about_heading(inputs)
	if (locale === "ru") return ru_about_heading(inputs)
	if (locale === "tr") return tr_about_heading(inputs)
	if (locale === "hi") return hi_about_heading(inputs)
	if (locale === "id") return id_about_heading(inputs)
	if (locale === "ms") return ms_about_heading(inputs)
	if (locale === "cs") return cs_about_heading(inputs)
	if (locale === "el") return el_about_heading(inputs)
	if (locale === "he") return he_about_heading(inputs)
	if (locale === "af") return af_about_heading(inputs)
	if (locale === "hu") return hu_about_heading(inputs)
	return en_about_heading(inputs)
});